import React, { useState, useEffect, useCallback } from "react";
import "./BackgroundMusic.css";

interface BackgroundMusicProps {
  audioRef: React.RefObject<HTMLAudioElement | null>;
  onPlayStateChange?: (playing: boolean) => void;
}

const BackgroundMusic: React.FC<BackgroundMusicProps> = ({ audioRef, onPlayStateChange }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handlePlay = () => {
      setIsPlaying(true);
      onPlayStateChange?.(true);
    };
    const handlePause = () => {
      setIsPlaying(false);
      onPlayStateChange?.(false);
    };

    audio.addEventListener("play", handlePlay);
    audio.addEventListener("pause", handlePause);

    // Check if already playing
    if (!audio.paused) {
      setIsPlaying(true);
      onPlayStateChange?.(true);
    }

    return () => {
      audio.removeEventListener("play", handlePlay);
      audio.removeEventListener("pause", handlePause);
    };
  }, [audioRef, onPlayStateChange]);

  const togglePlay = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play().catch(() => {});
    }
  }, [audioRef, isPlaying]);

  return (
    <div className="background-music">
      <button
        className={`music-visualizer ${isPlaying ? "playing" : ""}`}
        onClick={togglePlay}
        aria-label={isPlaying ? "Pause music" : "Play music"}
        title={isPlaying ? "Pause music" : "Play music"}
      >
        <div className="visualizer-bars">
          <span className="bar bar-1"></span>
          <span className="bar bar-2"></span>
          <span className="bar bar-3"></span>
          <span className="bar bar-4"></span>
          <span className="bar bar-5"></span>
        </div>
      </button>
    </div>
  );
};

export default BackgroundMusic;
